import React from "react";
import Banner from "./Banner";
import dynamic from "next/dynamic";
const BuildSection = dynamic(() => import("@/Components/BuildSection"),{ssr: true});
const LatestNumber = dynamic(() => import("./LatestNumber"),{ssr: true});
const Software = dynamic(() => import("./software"),{ssr: true});
const Systems = dynamic(() => import("./systems"),{ssr: true});
const WhyTrootech = dynamic(() => import("./whytrootech"),{ssr: true});
const Faq = dynamic(() => import("../Home/Faq"),{ssr: true});
const RFPForm = dynamic(() => import("../Home/Quote"),{ssr: true});
const HocHead = dynamic(() => import("@/Components/HigherOrderComponent/HocHead"),{ssr: true});

type IndustryProps = {
  blocks?: any;
  parent?: string;
  data?: any;
  seo?: any;
  breadcrumbs?: any;
  isMobile?: boolean | undefined;
};
const  IndustryPageNew: React.FC<IndustryProps> = ({
  blocks,
  isMobile,
  seo,
  parent,
  breadcrumbs,
}) => {
  return (
    <>
      {seo && <HocHead seo={seo} />}
      <div>
        <div className="manufacturing">
          {blocks?.map((block: any, i: number) => {
            switch (block?.__component) {
              case "blocks.2025-manufacturing-banner":
                return (
                  <Banner
                    key={i}
                    data={block}
                    parent={parent}
                    isMobile={isMobile}
                    breadcrumbs={breadcrumbs}
                  />
                );
              case "blocks.latest-number":
                return (
                  <LatestNumber key={i} data={block} isMobile={isMobile} />
                );
              case "blocks.manfacturing-software":
                return <Software key={i} data={block} isMobile={isMobile} />;
              case "blocks.future-ready-system":
                return <Systems key={i} data={block} isMobile={isMobile} />;
              case "shared.2025-action-card":
                return <BuildSection key={i} data={block} />;
              case "blocks.why-trootech":
                return <WhyTrootech key={i} data={block} isMobile={isMobile} />;
              case "blocks.2025-home-fa-qs":
                return <Faq key={i} data={block} />;
              case "blocks.2025-home-rfp":
                return <RFPForm key={i} data={block} />;
              default:
                return (
                  <div
                    key={i}
                    className="text-red-500 p-4 bg-red-50 border border-red-200 rounded-md mt-4 max-w-[1500px] mx-auto"
                  >
                    Unknown block type: {block?.__component || "undefined"}
                  </div>
                );
            }
          })}
        </div>
      </div>
    </>
  );
}

export default IndustryPageNew;
